/**
 * Single source of truth for record-status presentation — label + the color
 * classes used by the badge and the detail-panel status banner. Anything that
 * needs to color a status pulls from here instead of hardcoding emerald/blue/
 * orange/red/yellow inline.
 */
import type { RecordStatus } from '../api/records-api'

export interface RecordStatusStyle {
  label: string
  /** Pill/badge classes (subtle bg + text). */
  badgeClass: string
  /** Full-width banner classes (bg + border + text). */
  bannerClass: string
}

export const RECORD_STATUS_CONFIG: Record<RecordStatus, RecordStatusStyle> = {
  draft: {
    label: 'پیش‌نویس',
    badgeClass: 'bg-muted text-muted-foreground',
    bannerClass: 'bg-muted/40 border-border text-muted-foreground',
  },
  in_progress: {
    label: 'در جریان',
    badgeClass: 'bg-blue-500/15 text-blue-400',
    bannerClass: 'bg-blue-500/10 border-blue-500/20 text-blue-400',
  },
  submitted_for_review: {
    label: 'ارسال برای بررسی',
    badgeClass: 'bg-yellow-500/15 text-yellow-400',
    bannerClass: 'bg-blue-500/10 border-blue-500/20 text-blue-400',
  },
  under_review: {
    label: 'در حال بررسی',
    badgeClass: 'bg-orange-500/15 text-orange-400',
    bannerClass: 'bg-orange-500/10 border-orange-500/20 text-orange-400',
  },
  approved: {
    label: 'تأیید شده',
    badgeClass: 'bg-emerald-500/15 text-emerald-400',
    bannerClass: 'bg-emerald-500/10 border-emerald-500/20 text-emerald-400',
  },
  needs_revision: {
    label: 'نیاز به اصلاح',
    badgeClass: 'bg-red-500/15 text-red-400',
    bannerClass: 'bg-red-500/10 border-red-500/20 text-red-400',
  },
}

/** Banner copy keyed by status (the in-panel status strip). */
export const RECORD_STATUS_BANNER_TEXT: Partial<Record<RecordStatus, string>> = {
  submitted_for_review: 'در انتظار بررسی',
  under_review: 'در حال بررسی',
  approved: 'تأیید شده',
  needs_revision: 'نیاز به اصلاح',
}
